<template>
  <div class="contest-form-container">
    <form novalidate @submit.prevent="validateForm()">
      <div class="field">
        <p class="control">
          <input type="text" name="name" class="input" :class="{ 'is-danger': errors.has('name') }" :placeholder="$t('common.name')" v-model="name" v-validate="'required'">
        </p>
        <p class="help is-danger" v-show="errors.has('name')">{{ errors.first('name') }}</p>
      </div>
      <div class="field">
        <p class="control">
          <input type="email" name="email" class="input" :class="{ 'is-danger': errors.has('email') }" :placeholder="$t('common.email')" v-model="email" v-validate="'required|email'">
        </p>
        <p class="help is-danger" v-show="errors.has('email')">{{ errors.first('email') }}</p>
      </div>
      <!--<div class="field">
        <p class="control is-checkbox">
          <label class="checkbox">
            <input type="checkbox" name="confirm" v-model="confirm" v-validate="'required'">
            {{ $t('home.contest.confirm') }}
          </label>
        </p>
      </div>-->
      <div class="field">
        <p class="control">
          <vue-recaptcha ref="captcha" :sitekey="recaptchaKey" theme="dark" @verify="onCaptchaVerify"></vue-recaptcha>
        </p>
      </div>
      <div class="field">
        <p class="control">
          <button type="submit" class="button" :class="{ 'is-loading': isSubmitted }" :disabled="errors.any()">{{ $t('common.send') }}</button>
        </p>
      </div>
    </form>

    <div class="modal" :class="{ 'is-active': modalOpened }">
      <div class="modal-background" @click="closeModal()"></div>
      <div class="modal-content">
        <article class="message is-primary" v-if="success">
          <div class="message-header">
            <p>{{ $t('home.contest.title') }}</p>
            <button class="delete" @click="closeModal()"></button>
          </div>
          <div class="message-body">
            {{ $t('home.contest.confirmation.success') }}
          </div>
        </article>

        <article class="message is-danger" v-if="!success">
          <div class="message-header">
            <p>{{ $t('home.contest.title') }}</p>
            <button class="delete" @click="closeModal()"></button>
          </div>
          <div class="message-body">
            {{ message }}
          </div>
        </article>
      </div>

      <!--<div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title"></p>
          <button class="delete"></button>
        </header>
        <section class="modal-card-body">

        </section>
      </div>-->
    </div>
  </div>
</template>

<script>
import Icon from '../components/Icon'
import VueRecaptcha from 'vue-recaptcha'

export default {
  data () {
    return {
      name: '',
      email: '',
      confirm: false,
      isSubmitted: false,
      success: false,
      message: '',
      modalOpened: false,
      recaptchaKey: process.env.RECAPTCHA_KEY,
      response: ''
    }
  },
  methods: {
    onCaptchaVerify: function (response) {
      this.response = response
    },
    validateForm: function () {
      this.$validator.validateAll()

      if (!this.errors.any()) {
        if (this.response.length === 0) {
          this.message = this.$t('home.contest.confirmation.error.invalidCaptcha')
          this.openModal(false)
        } else {
          this.send()
        }
      }
    },
    send: function () {
      this.isSubmitted = true
      this.$http.post('contest/submit', { name: this.name, email: this.email, 'g-recaptcha-response': this.response })
        .then(() => {
          this.openModal(true)
          this.clearForm()
          this.isSubmitted = false

          setTimeout(() => {
            this.errors.clear()
          }, 1000)
        })
        .catch(error => {
          switch (error.status) {
            case 409:
              this.message = this.$t('home.contest.confirmation.error.emailAlreadyExists')
              break
            default:
              this.message = this.$t('home.contest.confirmation.error.unknown')
              break
          }

          this.openModal(false)
          this.isSubmitted = false
        })

      this.$refs.captcha.reset()

      this.$ga.event('contest', 'submit', 'Prelaunch')
    },
    clearForm: function () {
      this.name = ''
      this.email = ''
      this.confirm = false
    },
    openModal: function (isSuccess) {
      this.success = isSuccess
      this.modalOpened = true
    },
    closeModal: function () {
      this.modalOpened = false
    }
  },
  components: {
    Icon,
    VueRecaptcha
  }
}
</script>


<style lang="scss" scoped>
@import '../assets/styles/_variables.scss';

$red: #FF0000;

$color: #6739B8;
$background-color: #C9B3ED;

.field {
  width: 100%;

  &.is-grouped {
    justify-content: space-between;
  }
}

.control.is-checkbox {
  flex: 1 1;
}

.help.is-danger {
  color: $red;
}


.input[type=text],
.input[type=email],
.checkbox,
.button {
  width: 100%;
  background: $background-color;
  border: 1px solid $color;

  &.is-danger {
    border-color: $red;
  }
}

.checkbox {
  padding: calc(0.375em - 1px) calc(0.625em - 1px);
  color: $white;
  border: none;
  background: none;
  font-size: 0.7rem;
}

.button {
  color: $color;
  text-transform: uppercase;
  font-weight: $weight-bold;
}

::-webkit-input-placeholder {
  color: $color
}
:-moz-placeholder {
  color: $color;
  opacity: 1;
}
::-moz-placeholder {
  color: $color;
  opacity: 1;
}
:-ms-input-placeholder {
  color: $color;
}
::-ms-input-placeholder {
  color: $color
}

@media screen and (min-width: $desktop) and (max-width: $widescreen) {
  .level-left + .level-right {
    margin-top: 1.5rem;
  }
}

</style>



// WEBPACK FOOTER //
// ContestForm.vue?371faa32